var render = function render(){var _vm=this,_c=_vm._self._c;return _c('day-overview',{attrs:{"selected-date":"2020-12-30"}})
}
var staticRenderFns = []

export { render, staticRenderFns }